/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, Input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { ActionCardHeader } from './action-card.model';

@Component({
  selector: 'ods-action-card',
  imports: [IconComponent],
  template: `@if (header) {
      <div class="bg-background-150 text-text flex items-center justify-between gap-3 p-5">
        <span
          class="font-semibold"
          role="heading"
          [attr.aria-level]="header.headingLevel ?? DEFAULT_HEADING_LEVEL"
          data-test-id="action-card-headline"
        >
          {{ header.headline }}
        </span>
        <span class="flex items-center gap-2">
          @if (header.text) {
            <span data-test-id="action-card-header-text">{{ header.text }}</span>
          }
          @if (header.icon) {
            <ods-icon
              [name]="header.icon"
              [config]="{ fill: header.iconFill ?? 'primary' }"
              data-test-id="action-card-header-icon"
            />
          }
        </span>
      </div>
    } @else {
      <div class="bg-background-150 flex items-center justify-between gap-3 p-5 empty:hidden">
        <ng-content select="[action-card-header]" />
      </div>
    }
    <div class="p-5">
      <ng-content />
    </div>
    <ng-content select="ods-action-card-footer-buttons" />`,
  host: {
    class: 'block border-grayborder bg-background-100 shadow-grayborder overflow-hidden rounded-md border shadow',
  },
})
export class ActionCardComponent {
  @Input() header: ActionCardHeader;

  public readonly DEFAULT_HEADING_LEVEL: number = 4;
}
